import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [videoEnterA, setVideoEnterA] = useState(false);
    let controller: any;

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.imgShowCard .card-cur-video`,
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1.2, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });
        sceneA1.on('leave', function () {
            setVideoEnterA(false);
        });

        controller.addScene(sceneA1);
    }, []);

    const gloObj: any = {
        objA: {
            title: t('presale.product.img_show_2kWh_batteries'),
            list: [
                {
                    id: 'a1',
                    src: ['2kwh-1.webp', '2kwh-1.png'],
                    video: handleDynamicPath('/video/mm100/200-h5Video1.mp4'),
                    text: t('presale.product.img_show_a1_text'),
                },
                {
                    id: 'a2',
                    src: ['2kwh-2.webp', '2kwh-2.png'],
                    video: handleDynamicPath('/video/mm100/200-h5Video2.mp4'),
                    text: t('presale.product.img_show_a2_text'),
                },
                {
                    id: 'a3',
                    src: ['2kwh-3.webp', '2kwh-3.png'],
                    video: handleDynamicPath('/video/mm100/200-h5Video3.mp4'),
                    text: t('presale.product.img_show_a3_text'),
                },
            ],
        },
        objB: {
            title: t('presale.product.img_show_5kWh_batteries'),
            list: [
                {
                    id: 'a1',
                    src: ['5kwh-1.webp', '5kwh-1.png'],
                    video: handleDynamicPath('/video/mm100/500-h5Video1.mp4'),
                    text: t('presale.product.img_show_a1_text'),
                },
                {
                    id: 'a2',
                    src: ['5kwh-2.webp', '5kwh-2.png'],
                    video: handleDynamicPath('/video/mm100/500-h5Video2.mp4'),
                    text: t('presale.product.img_show_a2_text'),
                },
                {
                    id: 'a3',
                    src: ['5kwh-3.webp', '5kwh-3.png'],
                    video: handleDynamicPath('/video/mm100/500-h5Video3.mp4'),
                    text: t('presale.product.img_show_a3_text'),
                },
            ],
        },
    };
    const [curType, setCurType] = useState('objA');
    const [curList, setCurList] = useState(gloObj?.objA?.list || []);
    const [curItem, setCurItem] = useState(gloObj?.objA?.list[0] || {});

    const clickT1 = (typeStr: string) => {
        const newList = gloObj[typeStr].list || [];
        setCurType(typeStr);
        setCurList(newList);
        clickT2(newList[0] || {});
    };
    const clickT2 = (item: any) => setCurItem(item);

    return (
        <div className={`${css.imgShowCard} imgShowCard`}>
            <div className="kit-inter">
                <div className="card-btns">
                    <div className={`card-btn ${curType == 'objA' ? 'active' : ''}`} onClick={() => clickT1('objA')}>
                        <div className="btn-text">{gloObj?.objA?.title}</div>
                    </div>
                    <div className={`card-btn ${curType == 'objB' ? 'active' : ''}`} onClick={() => clickT1('objB')}>
                        <div className="btn-text">{gloObj?.objB?.title}</div>
                    </div>
                </div>
                <div className="card-cur-text">{curItem.text}</div>
                <div className="card-cur-video">{videoEnterA && <video src={curItem.video} className="video" muted playsInline autoPlay preload="auto" />}</div>
                <div className="card-items">
                    {curList?.map((item: any) => (
                        <div className={`card-item ${curItem.id == item.id ? 'active' : ''}`} key={item.id} onClick={() => clickT2(item)}>
                            <div className="img-box">
                                <EFPic name={[item.src[0], item.src[1]]} className="fullImgs" alt="" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
